import {CustomConfirm} from "functions/CustomConfirm";
import {$, $$} from "functions/dom";
import axios from "axios";
import {NotificationToast} from "functions/NotificationToast";


/**
 * Dialog de confirmation lors de suppresion de donnée
 */
export function confirmationDialogDelete(parentElement = null) {
    let prefix_element = parentElement ? parentElement + " " : ""
    let formDelete = $$(prefix_element + ".deleteForm");
    formDelete.forEach((item) => {
        item.addEventListener("submit", (e) => {
            e.preventDefault();
            let text = item.dataset.content
            CustomConfirm(item, text, item.dataset.btn)
        })
    })
}


/**
 * Affiche la liste des derniers notification
 */
export function showNotificationList() {
    let element = $(".JsShowNotification")
    element?.addEventListener('click', (e) => {
        let parent = element.parentElement
        parent?.querySelector(".notifications_list").classList.toggle("active")

        if (parseInt(element.dataset.badge, 10) > 0) {
            axios({
                method: 'post',
                url: "/mark-notifications-as-read",
                responseType: 'json',
            })
                .then(function (response) {
                    if (response.data.result === "success") {
                        element.dataset.badge = 0
                    }
                }).catch(function (error) {
                NotificationToast("error", error.message)
            });
        }
    })
}


/**
 * Check all table row data
 */
export function checkTableAllRow() {
    let checkboxAll = document.querySelectorAll(".checkboxAll")
    checkboxAll.forEach((element) => {
        element.addEventListener('click', () => {
            if (!element.checked) {
                element.setAttribute("title", "Tout sélectionner")
            } else {
                element.setAttribute("title", "Tout désélectionner")
            }

            const parent = element.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement
            check_all(parent, element.checked).then(r => null)
        })

        async function check_all(element, state) {
            let allCheck = element.querySelectorAll('tbody .checkboxItem')
            allCheck.forEach((item) => {
                item.checked = state
            })
        }
    })
}


export function exportXlsxFile(source = document) {
    let excel_export_link = source.querySelectorAll(".excel_export_link")
    excel_export_link.forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault()
            let animate = document.querySelector(".spinner__loader")
            animate.classList.add("active")

            axios({
                method: 'GET',
                url: item.href,
                responseType: 'blob',
            })
                .then(function (response) {
                    const _content_disp = response.headers['content-disposition']
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', _content_disp.split(";")[1].split('filename="')[1].split('"')[0]);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    animate.classList.remove("active")
                    NotificationToast("success", "Exportation reussi");
                })
                .catch(function (error) {
                    animate.classList.remove("active")
                    NotificationToast("error", error);
                });
        })
    })
}

export function toggleMeilisearchSearchModal() {
    let employes_search_box = document.querySelector(".employes_search_box")
    if (employes_search_box.classList.contains("active")) {
        employes_search_box.classList.remove("active");
        document.querySelector("body").style.overflow = "auto"
        document.querySelector(".ais-SearchBox-reset")?.click()
    } else {
        employes_search_box.classList.add("active");
        document.querySelector("body").style.overflow = "hidden"
    }
}

/**
 * Format number
 * @param number
 * @param decimals
 * @param dec_point
 * @param thousands_sep
 * @returns {string}
 */
export function number_format(number, decimals, dec_point, thousands_sep) {
    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    let n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            const k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

export const slugify = str =>
    str
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
